import { createClient, type SanityClient } from "@sanity/client";
import { createImageUrlBuilder, type SanityImageSource } from "@sanity/image-url";
import type { PortableTextBlock } from "@portabletext/types";

export const sanityClient: SanityClient = createClient({
  projectId: "8af5hqys",
  dataset: "production",
  apiVersion: "2024-01-01",
  useCdn: true,
  perspective: "published",
});

const builder = createImageUrlBuilder(sanityClient);
export const urlForImage = (source: SanityImageSource) => builder.image(source);

export type SanityImage = {
  asset: { _ref: string; _type: "reference" };
  alt?: string;
  hotspot?: unknown;
  crop?: unknown;
};

export type PostCategory = "product" | "company" | "research";

export const CATEGORY_LABELS: Record<PostCategory, string> = {
  product: "Product",
  company: "Company",
  research: "Research",
};

export type PostListItem = {
  _id: string;
  title: string;
  slug: string;
  excerpt?: string;
  mainImage?: SanityImage;
  author?: string;
  category?: PostCategory;
  publishedAt: string;
  body?: PortableTextBlock[];
};

export type Post = PostListItem & {
  body: PortableTextBlock[];
  seo?: {
    metaTitle?: string;
    metaDescription?: string;
    ogImage?: SanityImage;
  };
};

export const postListQuery = `*[_type == "post" && status == "published" && defined(slug.current)]
  | order(publishedAt desc) {
    _id,
    title,
    "slug": slug.current,
    excerpt,
    mainImage,
    author,
    category,
    publishedAt,
    body
  }`;

export const postBySlugQuery = `*[_type == "post" && status == "published" && slug.current == $slug][0] {
  _id,
  title,
  "slug": slug.current,
  excerpt,
  mainImage,
  author,
  category,
  publishedAt,
  body,
  seo
}`;

export const allSlugsQuery = `*[_type == "post" && status == "published" && defined(slug.current)].slug.current`;
